import { useMemo } from 'react';
import { User } from '../types/User';
import { Group } from '../types/Group';
import { getGroupNames, getRoleLabel } from '../utils/userUtils';

const useFilteredUsers = (
    users: User[] = [],
    searchText: string,
    selectedRoles: string[],
    selectedGroups: string[],
    allGroups: Group[]
) => {
    return useMemo(() => {
        if (!users || users.length === 0) {
            return [];
        }
        
        return users.filter(user => {
            const matchesSearch =
                (user.name?.toLowerCase() || '').includes(searchText.toLowerCase()) ||
                (user.login?.toLowerCase() || '').includes(searchText.toLowerCase()) ||
                getGroupNames(user.groups, allGroups).toLowerCase().includes(searchText.toLowerCase()) ||
                getRoleLabel(user).includes(searchText.toLowerCase());
            const matchesRole =
                selectedRoles.length === 0 || selectedRoles.includes(getRoleLabel(user));
            const userGroupUids = user.groups.map(g => typeof g === 'string' ? g : g.uid);
            const matchesGroup =
                selectedGroups.length === 0 || userGroupUids.some(uid => selectedGroups.includes(uid));
            return matchesSearch && matchesRole && matchesGroup;
        });
    }, [users, searchText, selectedRoles, selectedGroups, allGroups]);
};

export default useFilteredUsers; 